import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { FontSizeProvider } from './components/contexts/AccessibilityContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { REACT_APP_GOOGLE_CLIENT_ID } from './utils/constants';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_CLIENT_ID || ''}>
    <FontSizeProvider>
      <App />
    </FontSizeProvider>
  </GoogleOAuthProvider>
);
